
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/info/traits",
      function () {
        return require("private-next-pages/info/traits/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/info/traits"])
      });
    }
  